/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./creative-direction-config.vue?vue&type=template&id=2f3d1bba&scoped=true&"
import script from "./creative-direction-config.vue?vue&type=script&lang=js&"
export * from "./creative-direction-config.vue?vue&type=script&lang=js&"
import style0 from "./creative-direction-config.vue?vue&type=style&index=0&id=2f3d1bba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3d1bba",
  null
  
)

export default component.exports